// File: client/src/variants/zombie/index.js
// Zombie Chess as a platform plugin.

import rulebook from './rulebook';
import { useZombieRuntime } from './useZombieRuntime';

const zombieVariant = {
  id: 'zombie',
  name: 'Zombie Chess',
  tagline: 'Captured pieces rise again — as your zombies. Build a horde.',
  icon: '🧟',
  accent: 'from-green-700 to-emerald-900',
  supportedGameTypes: ['ai', 'local'],
  order: 3,
  rulebook,
  useRuntime: useZombieRuntime,
};

export default zombieVariant;
